/**
 * ¿Hay una ficha de cliente a la que volver desde el Explorador, y cuál? (card 1Ft2oNtA)
 *
 * El Explorador es una pantalla de AGENCIA. Al entrar desde la ficha de un cliente —la pestaña
 * «Explorador de datos», que linkea con `?client_id=`— se pierden de golpe la miga «Clientes ›
 * cliente» y las cuatro pestañas que se mantenían entre Panel, Configuración, Portal y AI Booster,
 * y no queda camino de vuelta.
 *
 * Lo que se ofrece es la VUELTA, no la cabecera entera: montar las pestañas de un cliente dentro de
 * una pantalla que no es de ese cliente mentiría sobre dónde está parado el usuario, y era el
 * reparo con el que Pablo trajo el tema («por ahí se agregan demasiadas cosas arriba»).
 *
 * ⚠️ Desde el 02/10 esa premisa ya no vale para Informes en la 2.1: desde el 27/09 todas las
 * agencias migran a Informes y cada informe es de UN cliente, así que la pantalla SÍ es de ese
 * cliente. fede eligió la opción C del mockup (card 7yIKxqZj): en la 2.1 Informes es una solapa
 * real de la ficha (`/client/:id/informes[/:informeId]`), con la miga y las pestañas a la vista, y
 * este «Volver» no se dibuja ahí. Sigue valiendo para el Explorador y para Informes en el marco
 * clásico, donde la ficha no tiene solapa Informes y la pantalla sigue siendo de agencia.
 *
 * Vive afuera del componente porque es la parte que puede romperse: el header monta medio Explorador
 * y no se puede afirmar nada sobre él sin montarlo entero.
 */

export function backToClientFor({cameFromClient, agencyClientId, agencyClients}) {
    // Sin procedencia no hay vuelta: quien entró por el menú de la agencia no viene de ningún lado.
    if (!cameFromClient || !agencyClientId) return null;

    // El cliente SELECCIONADO, no el de la URL: si el usuario cambió de cliente en el selector,
    // «volver» al anterior lo llevaría a una ficha que ya no está mirando. Se compara como texto
    // porque el id de la URL llega string y el del catálogo es número.
    const client = (agencyClients || []).find(
        each => String(each.id) === String(agencyClientId));
    if (!client) return null;

    // `/client/:id` es la RAÍZ de la ficha y resuelve sola a Panel (2.1) o Monitoreo (clásico): la
    // vuelta no tiene que saber en qué generación de la interfaz está el usuario.
    return {id: client.id, name: client.name, path: `/client/${client.id}`};
}
